import React from 'react';

import styles from './CardOutline.module.scss';

const { 'card-outline': cardOutlineClass } = styles;

const CardOutline = ({ children, customClass }) => {
  return <div className={`${cardOutlineClass} ${customClass}`}>{children}</div>;
};

export default CardOutline;
